import classNames from "classnames";
import { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { Icon } from "src/app/components/icon/Icon";
import Loader from "src/app/components/loader/Loader";
import { ROUTES } from "src/config/constants";
import { AuthContext } from "src/contexts/AuthContext";
import { ModalContext } from "src/contexts/ModalContext";
import { ApiResult } from "src/core/helpers/api/ApiResult";
import { AuthenticateResponse } from "src/core/models/auth";
import { AccountsService } from "src/core/services/auth";

import authCSS from "../Auth.module.css";

const ResetPassword = () => {
  const modalData = useContext(ModalContext);
  const [loading, setLoading] = useState(false);
  const [passwordType, setPasswordVisibility] = useState(false);
  const [currentState, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const authData = useContext(AuthContext);
  const location = useLocation();
  let history = useHistory();

  const search = location.search;
  const params = new URLSearchParams(search);
  const email = params.get("email");
  const token = params.get("token");
  const isPasswordVisible = passwordType === false;

  const changePasswordType = () => {
    setPasswordVisibility(!passwordType);
  };

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const inputName = event.target.name;
    const inputValue = event.target.value;

    setFormData((currentState) => {
      return {
        ...currentState,
        [inputName]: inputValue,
      };
    });
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    setLoading(true);
    AccountsService.resetPassword({
      email: email ?? "",
      token: token ?? "",
      password: currentState.password,
      confirmPassword: currentState.confirmPassword,
    })
      .then((response: any) => {
        modalData?.triggerSuccess(response);
        if (!authData?.auth && email) {
          loginUser(email, currentState.password);
        } else {
          history.push(ROUTES.home);
        }
      })
      .catch((e: ApiResult) => {
        if (!modalData?.content?.contentSet) {
          modalData?.triggerError(e);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loginUser = (email: string, password: string) => {
    AccountsService.authenticate({ email: email, password: password })
      .then((response: AuthenticateResponse) => {
        if (response?.jwtToken) {
          authData?.setAuthData(response, true);
          history.push(ROUTES.home);
        }
      })
      .catch((e: ApiResult) => {
        modalData?.triggerError(e);
      });
  };

  return (
    <div className={classNames("u-bg-background", "u-flex", "u-flex-content-center", "u-flex-items-center", "u-pos-relative", authCSS.container)}>
      <div className={classNames("u-flex", "u-flex-column", "u-flex-items-center", authCSS.resetPass)}>
        <h3 className="u-t-primary-dark u-t-align-center u-t-uppercase u-m0 u-pt10px u-pb40px">ponovno postavljanje lozinke</h3>
        <p className="u-t-align-center u-t-f18p u-t-w400 u-m0 u-pb40px">Unesite novu lozinku:</p>
        <form onSubmit={handleSubmit} className={classNames("u-col-xs-12", "u-col-sm-8", "u-col-md-6", "u-col-lg-7", authCSS.loginForm)}>
          <div className="u-flex u-flex-column">
            <label htmlFor="password" className="u-t-f14p u-ml10px">
              Lozinka
            </label>
            <div className="u-col-xs-12">
              <input
                type={passwordType ? "text" : "password"}
                name="password"
                onChange={onInputChange}
                className="u-col-xs-12 u-t-f15p u-mb30px u-border-box"
                required
              ></input>
              <button type="button" className={classNames("u-cursor-pointer", "u-pos-absolute", authCSS.eyeIcon)} onClick={changePasswordType}>
                <Icon name={isPasswordVisible ? "eye-blocked" : "eye"} className="u-t-valign-mid u-t-primary" />
              </button>
            </div>
          </div>
          <div className="u-flex u-flex-column u-mb50px">
            <label htmlFor="confirmPassword" className="u-t-f14p u-ml10px">
              Ponovite lozinku
            </label>
            <div className="u-col-xs-12">
              <input
                type={passwordType ? "text" : "password"}
                name="confirmPassword"
                onChange={onInputChange}
                className="u-col-xs-12 u-t-f15p u-border-box"
                required
              ></input>
              <button type="button" className={classNames("u-cursor-pointer", "u-pos-absolute", authCSS.eyeIcon)} onClick={changePasswordType}>
                <Icon name={isPasswordVisible ? "eye-blocked" : "eye"} className="u-t-valign-mid u-t-primary" />
              </button>
            </div>
          </div>

          <div className="u-flex u-flex-content-center u-mb50px">
            <button
              type="submit"
              className={classNames(
                "u-bg-primary",
                "u-t-white",
                "u-cursor-pointer",
                "u-t-uppercase",
                "u-col-xs-12",
                "u-col-lg-10",
                "u-col-md-9",
                "u-font-family-inh",
                "u-t-f16p",
                "u-t-lh24",
                authCSS.button
              )}
            >
              {authData?.auth && "Spremi"}
              {!authData?.auth && "Spremi i prijavi se"}
            </button>
          </div>
        </form>
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default ResetPassword;
